import React from "react"
import { GlobalDataContext } from "../layouts"
import InputBox, { INPUT_COLOUR } from "./InputBox"

const MISTRAL_TEST_LIST =
  "https://mistralvp.us18.list-manage.com/subscribe/post?u=a7f84395c9c1323f06833ebab&amp;id=71ff40a4e5"

const PodcastSignupBar = ({ className }) => {
  const globalData = React.useContext(GlobalDataContext)

  return (
    <div className={`bg-mvp-dark-blue py-6 md:py-10 lg:py-20 ${className}`}>
      <div className="container">
        <div
          className="flex flex-col items-center justify-evenly
          md:flex-row
          2xl:px-20"
        >
          <div
            className="text-mvp-light-blue font-light text-36px mb-4
            md:text-4xl md:pr-10 md:mb-0
            lg:flex-grow lg:pr-0"
          >
            {globalData.podcastSignupTitle}
          </div>
          <InputBox
            colour={INPUT_COLOUR.LIGHT_BLUE}
            buttonLabel={globalData.podcastSignupButton}
            placeholderLabel={globalData.podcastSignupInputPlaceholder}
            className="w-full md:w-auto md:flex-grow"
            buttonClasses="w-full ml-auto mr-auto md:w-auto md:ml-0 md:mr-0"
            mailchimpList={MISTRAL_TEST_LIST}
            signupSuccessMessage={globalData.podcastSignupSuccess}
            signupSuccessMessageClasses="text-mvp-light-blue"
          />
        </div>
      </div>
    </div>
  )
}

export default PodcastSignupBar
